export default __webpack_public_path__ + "static/media/gl_delete-20.83238054.svg";